var _desc, _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCreateFolderIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "view-box": "-0.5 -0.5 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    id: "Folder-Add--Streamline-Ultimate",
    height: 14,
    width: 14,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Folder Add Streamline Icon: https://streamlinehq.com")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m4.468750000000001 10.156250000000002 -3.1432916666666673 0",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.968750000000002 4.468750000000001v-1.6250000000000002a0.8125000000000001 0.8125000000000001 0 0 0 -0.8125000000000001 -0.8125000000000001H4.468750000000001v-0.8125000000000001a0.8125000000000001 0.8125000000000001 0 0 0 -0.8125000000000001 -0.8125000000000001h-2.4375000000000004a0.8125000000000001 0.8125000000000001 0 0 0 -0.8125000000000001 0.8125000000000001v8.016666666666667a0.9208333333333334 0.9208333333333334 0 0 0 1.8070000000000002 0.23725000000000004l1.2734583333333336 -4.41675A0.8125000000000001 0.8125000000000001 0 0 1 4.267791666666667 4.468750000000001H11.781250000000002a0.8125000000000001 0.8125000000000001 0 0 1 0.7854166666666668 1.0215833333333335",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.093750000000001 9.343750000000002a3.2500000000000004 3.2500000000000004 0 1 0 6.500000000000001 0 3.2500000000000004 3.2500000000000004 0 1 0 -6.500000000000001 0Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m9.343750000000002 7.718750000000001 0 3.2500000000000004",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m7.718750000000001 9.343750000000002 3.2500000000000004 0",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateFolderIcon);
export default __webpack_public_path__ + "static/media/createFolderIcon.96b7f8b7bf2b0a647272bc576e34334e.svg";
export { ForwardRef as ReactComponent };